/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData(value) {
    if (!('AccountId' in value) || value['AccountId'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AccountId': json['account_id'],
        'Email': json['email'] == null ? undefined : json['email'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'account_id': value['AccountId'],
        'email': value['Email'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoAccountData.js.map